const ASTRO_CAREER_UNLOCK_MS = Date.UTC(2026, 0, 25, 0, 0, 0)

function getMoscowTimestamp(date: Date = new Date()): number {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Moscow',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
  const parts = formatter.formatToParts(date)
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value || 0)
  return Date.UTC(
    get('year'),
    get('month') - 1,
    get('day'),
    get('hour'),
    get('minute'),
    get('second')
  )
}

export function isAstroCareerUnlocked(date: Date = new Date()): boolean {
  return getMoscowTimestamp(date) >= ASTRO_CAREER_UNLOCK_MS
}

export function getAstroCareerCountdown(date: Date = new Date()) {
  const diff = Math.max(0, ASTRO_CAREER_UNLOCK_MS - getMoscowTimestamp(date))
  const totalSeconds = Math.floor(diff / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return { days, hours, minutes, seconds }
}
